import { z } from "zod";
import { AppConfigSchema } from "../../models/config.schema";

export const ConfigControllerResponseSchema = {
  getPublicConfig: z.object({
    configData: AppConfigSchema,
  }),
};
